import { atom } from 'jotai';

// True while a logline/synopsis generation job is streaming over SSE for this
// browser tab. Disables starting a second generation (the backend job is unique
// per project, and one snackbar can only follow one stream). Unlike the import
// marker this is not persisted: generation only fills in scene metadata, so a
// refresh mid-job simply loses the progress bar — the backend keeps running and
// the next read shows whatever it wrote.
export const generateResumeInProgressAtom = atom(false);
